import React from "react";
import styles from "./Downloads.module.css";
import Android from "../assets/android.png";
import Windows from "../assets/windows.png";

const Downloads = () => {
    return (
        <div className={styles.page}>
            {/* Hero Section */}
            <header className={styles.hero}>
                <h1>Download Our Applications</h1>
                <p>Choose your platform and get started instantly</p>
            </header>

            <main className={styles.content}>
                {/* Android Apps */}
                <section className={styles.platform}>
                    <div className={styles.platformHeader}>
                        <img src={Android} alt="Android" />
                        <h2>Android Apps</h2>
                    </div>
                    <div className={styles.cardGrid}>
                        <div className={styles.card}>
                            <h3>Student Portal App</h3>
                            <p>
                                Manage your courses, assignments, grades, and more right from your
                                mobile device. Designed for students on the go.
                            </p>
                            <a
                                href="https://github.com/xeeshan-zs/Student-Portal-Android-App/releases/download/download/Student.Portal.apk"
                                download="student_portal.apk"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.downloadBtn}
                            >
                                Download APK
                            </a>
                        </div>
                    </div>
                </section>

                {/* Desktop Apps */}
                <section className={styles.platform}>
                    <div className={styles.platformHeader}>
                        <img src={Windows} alt="Windows" />
                        <h2>Desktop Apps</h2>
                    </div>
                    <div className={styles.cardGrid}>
                        <div className={styles.card}>
                            <h3>Grade Calculator</h3>
                            <p>
                                Keep track of your academic performance with ease. Calculate GPA,
                                manage grades, and plan ahead — all offline.
                            </p>
                            <a
                                href="https://students.atrons.net/assets/Grade%20Calculator-1.0.zip"
                                download="Grade%20Calculator-1.0.zip"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.downloadBtn}
                            >
                                Download for Windows
                            </a>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default Downloads;
